export default __webpack_public_path__ + "static/media/br.ad0a905f.svg";